import { Button, Paper, Stack, Typography } from "@mui/material";

function SimplyStillCard({
  title,
  videos,
  loading,
  onAdd,
  renderVideoSkeletons,
  renderUnifiedList,
  emptyText,
}) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 2,
        border: "1px solid #d0e2ff",
        background: "#f0f6ff",
        mb: 3,
      }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        sx={{ mb: 1 }}
      >
        <Typography variant="h6">{title}</Typography>
        <Button variant="contained" onClick={onAdd}>
          Add Video
        </Button>
      </Stack>
      {loading ? (
        renderVideoSkeletons(3)
      ) : videos.length === 0 ? (
        <Paper
          elevation={0}
          sx={{
            p: 3,
            border: "1px dashed #cbd5e1",
            background: "#fff",
            borderRadius: 2,
            color: "#607d8b",
            textAlign: "center",
          }}
        >
          {emptyText}
        </Paper>
      ) : (
        renderUnifiedList(videos, "video")
      )}
    </Paper>
  );
}

export default function SimplyStillSections({
  sections,
  renderVideoSkeletons,
  renderUnifiedList,
}) {
  return (
    <>
      {sections.map((section) => (
        <SimplyStillCard
          key={section.key}
          title={section.title}
          videos={section.items}
          loading={section.loading}
          onAdd={section.onAdd}
          renderVideoSkeletons={renderVideoSkeletons}
          renderUnifiedList={renderUnifiedList}
          emptyText={section.emptyText}
        />
      ))}
    </>
  );
}
